module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.5136cbe.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Regular.woff2
// module id = 455
// module chunks = 1